var map = {
	"./altramuces-alergenos-alimentarios-icono.png": "./src/style/alergenos/altramuces-alergenos-alimentarios-icono.png",
	"./apio-alergenos-alimentarios-icono.png": "./src/style/alergenos/apio-alergenos-alimentarios-icono.png",
	"./cacahuetes-alergenos-alimentarios-icono.png": "./src/style/alergenos/cacahuetes-alergenos-alimentarios-icono.png",
	"./crustáceos-alergenos-alimentarios-icono.png": "./src/style/alergenos/crustáceos-alergenos-alimentarios-icono.png",
	"./frutos-de-cáscara-alergenos-alimentarios-icono.png": "./src/style/alergenos/frutos-de-cáscara-alergenos-alimentarios-icono.png",
	"./gluten-alergenos-alimentarios-icono.png": "./src/style/alergenos/gluten-alergenos-alimentarios-icono.png",
	"./huevos-alergenos-alimentarios-icono.png": "./src/style/alergenos/huevos-alergenos-alimentarios-icono.png",
	"./lácteos-alergenos-alimentarios-icono.png": "./src/style/alergenos/lácteos-alergenos-alimentarios-icono.png",
	"./moluscos-alergenos-alimentarios-icono.png": "./src/style/alergenos/moluscos-alergenos-alimentarios-icono.png",
	"./mostaza-alergenos-alimentarios-icono.png": "./src/style/alergenos/mostaza-alergenos-alimentarios-icono.png",
	"./pescado-alergenos-alimentarios-icono.png": "./src/style/alergenos/pescado-alergenos-alimentarios-icono.png",
	"./soja-alergenos-alimentarios-icono.png": "./src/style/alergenos/soja-alergenos-alimentarios-icono.png",
	"./sulfitos-alergenos-alimentarios-icono.png": "./src/style/alergenos/sulfitos-alergenos-alimentarios-icono.png",
	"./sésamo-alergenos-alimentarios-icono.png": "./src/style/alergenos/sésamo-alergenos-alimentarios-icono.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/style/alergenos sync recursive ^\\.\\/.*\\-alergenos\\-alimentarios\\-icono\\.png$";